export const RUSH_EDIT = 'RUSH_EDIT';
export const BURN_IN_CAPTIONS = 'BURN_IN_CAPTIONS';

export const ADDONS_TO_BE_APPROVED = [RUSH_EDIT, BURN_IN_CAPTIONS];